<template>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M11.8945 4.44724C11.6475 4.94122 11.0468 5.14144 10.5528 4.89445L6.00003 2.61806L1.44724 4.89445C0.953259 5.14144 0.352587 4.94122 0.105597 4.44724C-0.141392 3.95326 0.058833 3.35259 0.552811 3.1056L6.00002 0.381992L11.4472 3.1056C11.9412 3.35259 12.1414 3.95326 11.8945 4.44724Z"
    fill="currentColor"
  />
</template>
